import { apiHelper } from '@/utils'
import { API } from '@/constants'
import { sharedHelper } from '@/utils';


export const cancelTypeService = {
    getAllcancelTypes,
    getcancelType,
    updatecancelType,
    updatecancelTypeStatus,
    createcancelType 
};

const MODULE = {
    TYPES: 'cancel-types',
}

// const API_URL = API.BASE_URL.replace('@serviceName', 'user') + '/v1'
const API_URL = API.BASE_URL + '/v1'


export function getAllcancelTypes(filter) {
    const requestOptions = {
        params: {
            page: filter.pageNumber,
            size: filter.pageSize,
            is_active: filter.isActive,
        }
    }

    let array = filter.searchArray
    array.forEach((word, index) => {
        if (word != null || word != '') {
            var searchParam = `search_words[${index}]`
            requestOptions.params[searchParam] = word
        }
    })
    return apiHelper(API_URL).get(`/${MODULE.TYPES}`, requestOptions)
}

export function getcancelType(id) {

    return apiHelper(API_URL).get(`/${MODULE.TYPES}/${id}`)
}

export function updatecancelType(data) {
    const formData = new FormData();
    sharedHelper.appendIfNotNull(formData,'name', data.name);
    formData.append('_method', "put");
    
    if (data.is_charge_money != "" && data.is_charge_money == true) {
        formData.append('is_charge_money', 1);
    }
    else {
        formData.append('is_charge_money', 0);
    }

    if (data.is_refund_money != "" && data.is_refund_money == true) {
        formData.append('is_refund_money', 1);
    }
    else {
        formData.append('is_refund_money', 0);
    }

    return apiHelper(API_URL).post(`/${MODULE.TYPES}/${data.id}`, formData)     
}

export function createcancelType(data) {
    const formData = new FormData();
    sharedHelper.appendIfNotNull(formData,'name', data.name);
    
    if (data.is_charge_money != "" && data.is_charge_money == true) {
        formData.append('is_charge_money', 1);
    }
    else {
        formData.append('is_charge_money', 0);
    }

    if (data.is_refund_money != "" && data.is_refund_money == true) {
        formData.append('is_refund_money', 1);
    }
    else {
        formData.append('is_refund_money', 0);
    }
    return apiHelper(API_URL).post(`/${MODULE.TYPES}`, formData)
}

export function updatecancelTypeStatus(data) {
    
    const requestOptions = {
        is_active: data.isActive
    }

    return apiHelper(API_URL).patch(`/${MODULE.TYPES}/${data.id}`, requestOptions)
}

